export default {
  STATUS: [
    { KEY: 0, VALUE: 'CRIADO', COLOR: '#AAB8C2' },
    { KEY: 1, VALUE: 'EM PROCESSAMENTO', COLOR: '#FFC158' },
    { KEY: 2, VALUE: 'APROVADO', COLOR: '#22D76A' },
    { KEY: 3, VALUE: 'DECLINADO', COLOR: '#E22020' },
    { KEY: 4, VALUE: 'CANCELADO', COLOR: '#E22020' },
  ],
  INVOICE_STATUS: {
    CLOSE: { KEY: 2, VALUE: 'Fechada' },
    OPEN: 'Aberta',
  },
  INVOICE_ERROR: 0,
  TAX_ACTIVE: 1,
  TYPES: [
    { KEY: 'CREDIT_CARD_CLEAN', VALUE: 'CARTÃO DE CRÉDITO - NOVO' },
    { KEY: 'CREDIT_CARD', VALUE: 'CARTÃO DE CRÉDITO - EXISTENTE' },
    { KEY: 'BOLETO', VALUE: 'BOLETO' },
    { KEY: 'PIX', VALUE: 'PIX' },
    { KEY: 'MONEY', VALUE: 'DINHEIRO' },
    { KEY: 'VOUCHER', VALUE: 'VOUCHER' },
    { KEY: 'REQUISITION', VALUE: 'REQUISICÃO' },
    { KEY: 'FREE', VALUE: 'GRATUIDADE' },
    { KEY: 'POS_PAID', VALUE: 'POS-PAGO' },
    { KEY: 'EXTERNAL', VALUE: 'PAGAMENTO EXTERNO' },
    { KEY: 'DEBIT_CARD', VALUE: 'CARTÃO DE DEBITO' },
  ],
  OPERATION_TYPES: [
    { KEY: 0, VALUE: 'CRÉDITO' },
    { KEY: 1, VALUE: 'DÉBITO' },
  ],
  ENTRY: [
    { KEY: 'TOKEN', VALUE: 'TOKEN' },
    { KEY: 'EMV', VALUE: 'CARTÃO EMV' },
    { KEY: 'TRANSPORT_CARD', VALUE: 'CARTÃO DE TRANSPORTE' },
    { KEY: 'BUTTON', VALUE: 'BOTOEIRA' },
    { KEY: 'EXTERN', VALUE: 'ENTRADA EXTERNA' },
    { KEY: 'FACIAL', VALUE: 'RECONHECIMENTO FACIAL' },
  ],
  TYPE: {
    PIX: 'PIX',
    FREE: 'FREE',
  },
  CHANNELS: [
    {
      KEY: 'BIPAY',
      VALUE: 'appUser',
      LABEL: 'Bipay',
    },
    {
      KEY: 'SELLING_POINT',
      VALUE: 'sellingTerminal',
      LABEL: 'Rede de Vendas',
    },
    {
      KEY: 'EMPLOYEE_APP',
      VALUE: 'employeeApp',
      LABEL: 'App de operação',
    },
    {
      KEY: 'ECOMMERCE',
      VALUE: 'website',
      LABEL: 'E-commerce',
    },
    {
      KEY: 'VT',
      VALUE: 'vt',
      LABEL: 'Vale Transporte',
    },
  ],
};
